const storageConfig = {
  defaultExpires: null, // never
  enableCache: true,
  sync: {
    auth: () => ({ }),
  },
};

export default storageConfig;
